import { render, staticRenderFns } from "./ForbiddenModal.vue?vue&type=template&id=ab8918e6&"
import script from "./ForbiddenModal.vue?vue&type=script&lang=js&"
export * from "./ForbiddenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports